import { render } from "./PageTitle.vue?vue&type=template&id=d7afad72&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=d7afad72&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7afad72"]])

export default __exports__